var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7096 10.082V3.08203C13.7096 2.69528 13.5559 2.32428 13.2826 2.05069C13.0091 1.7774 12.6381 1.6237 12.2513 1.6237H7.18156L7.0013 1.2632C6.75426 0.769117 6.24939 0.457031 5.69697 0.457031H1.7513C0.94601 0.457031 0.292969 1.11007 0.292969 1.91536V10.082C0.292969 10.8873 0.94601 11.5404 1.7513 11.5404H12.2513C12.6381 11.5404 13.0091 11.3867 13.2826 11.1134C13.5559 10.8398 13.7096 10.4688 13.7096 10.082ZM13.1263 4.2487V10.082C13.1263 10.3142 13.0341 10.5367 12.8699 10.7007C12.706 10.8649 12.4835 10.957 12.2513 10.957C9.81093 10.957 4.19168 10.957 1.7513 10.957C1.26801 10.957 0.876302 10.5653 0.876302 10.082V1.91536C0.876302 1.43207 1.26801 1.04036 1.7513 1.04036H5.69697C6.02831 1.04036 6.33134 1.22761 6.47951 1.52394L7.32388 3.2124C7.37317 3.31128 7.47409 3.3737 7.58464 3.3737H12.2513C12.4835 3.3737 12.706 3.46586 12.8699 3.63007C13.0341 3.79399 13.1263 4.01653 13.1263 4.2487ZM7.47322 2.20703L7.76489 2.79036H12.2513C12.5686 2.79036 12.8755 2.89391 13.1263 3.08203C13.1263 2.84986 13.0341 2.62732 12.8699 2.46341C12.706 2.2992 12.4835 2.20703 12.2513 2.20703H7.47322Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7f67cce926799cc5abba08e2c195b6a7.svg";
export { ForwardRef as ReactComponent };